import React, { Component } from "react";
import { DateBox, SelectBox } from "devextreme-react";
import Api from "Api/Api";
export default class ContractForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      investors_choice: [],
      investor: {},
      startup_choice: [],
      startup: []
    };
    this.createContract = e => {
      e.preventDefault();
      var form = document.forms["contractForm"];
      var data = {
        name: form.name.value,
        investor: this.state.investor,
        startup: this.state.startup,
        committed_amount: form.committed_amount.value,
        timeline: new Date(form.timeline.value),
        contract_type: form.contract_type.value
      };
      this.props.getData(data);
    };
    this.selectboxChanged = e => {
      this.setState({ [e.element.id]: e.value.id });
    };
  }
  componentDidMount() {
    Api.getAllInvestor().then(response => {
      if (response.status === 200) {
        this.setState({
          investors_choice: response.data
        });
      }
    });
    Api.getAllStartups().then(response => {
      if (response.status === 200) {
        this.setState({ startup_choice: response.data });
      }
    });
  }

  render() {
    return (
      <form onSubmit={this.createContract} name="contractForm">
        <div class="form-group">
          <label htmlFor="exampleInputEmail1">Investor's email</label>
          <input
            type="text"
            class="form-control"
            placeholder="Name of the contract"
            name="name"
          />
        </div>
        <div class="form-group">
          <label htmlFor="exampleInputEmail1">Investor</label>
          <SelectBox
            className={"remove-border-and-radius"}
            dataSource={this.state.investors_choice}
            displayExpr={"username"}
            placeholder={"Select Investor"}
            // value={this.state.investor}
            searchEnabled={true}
            onValueChanged={this.selectboxChanged}
            id="investor"
          />
        </div>
        <div class="form-group">
          <label htmlFor="exampleInputEmail1">Startup</label>
          <SelectBox
            className={"remove-border-and-radius"}
            dataSource={this.state.startup_choice}
            displayExpr={"name"}
            placeholder={"Select Startup"}
            searchEnabled={true}
            onValueChanged={this.selectboxChanged}
            id="startup"
          />
        </div>
        <div class="form-group">
          <label htmlFor="exampleInputEmail1">Commitment amount</label>
          <input
            type="number"
            class="form-control"
            placeholder="Amount committed"
            name="committed_amount"
          />
        </div>
        <div class="form-group">
          <label htmlFor="">Timeline</label>
          <DateBox
            type={"datetime"}
            stylingMode={"underlined"}
            style={{ width: "100%" }}
            name="timeline"
          />
        </div>
        <div class="form-group">
          <label htmlFor="exampleInputEmail1">Contract type</label>
          <input
            type="text"
            class="form-control"
            placeholder="Contract type"
            name="contract_type"
          />
        </div>
        <button type="submit" class="btn btn-primary">
          Create
        </button>
      </form>
    );
  }
}
